import axios from '@/libs/api.request'

export const SaveHelp = data => {
  return axios.request({
    url: '/print/help/save',
    method: 'post',
    data: data
  })
}
export const GetHelp = data => {
  return axios.request({
    url: '/print/help/list',
    method: 'get',
    params: data
  })
}
export const GetHelpTypes = data => {
  return axios.request({
    url: '/print/help/types',
    method: 'get',
    params: data
  })
}
export const GetHelpDetails = data => {
  return axios.request({
    url: '/print/help/details',
    method: 'get',
    params: data
  })
}
